import { render, staticRenderFns } from "./StyledModal.vue?vue&type=template&id=30e06de3&"
import script from "./StyledModal.vue?vue&type=script&lang=js&"
export * from "./StyledModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports